(function () {

  'use strict';

  angular.module('eclipseApp.core')

    .factory('prepaidCommonService', ['httpService', '$http', 'uteEndpoint', '$q', '$window', '$rootScope', '$state', '$filter', '$sessionStorage', 'janrainService', 'prepaidAirtimeBalanceService', 'prepaidAutoRefillInfoService', 'prepaidPlanInfoService', 'prepaidRegisteredCCInfoService', 'prepaidUserInfoService', 'uteLocale', function (httpService, $http, uteEndpoint, $q, $window, $rootScope, $state, $filter, $sessionStorage, janrainService, prepaidAirtimeBalanceService, prepaidAutoRefillInfoService, prepaidPlanInfoService, prepaidRegisteredCCInfoService, prepaidUserInfoService, uteLocale) {

      var service = {};
      var loading = false;
      var language = uteLocale.language;
      var subscriberNumberList = [];
      var planDesc = null;
      var planDataIncluded = null;
      var planUOM = null;
      var planPrice = null;
      var planTerm = null;
      var planfeatures = null;
      var planAndAddOnInfo = null;
      var addonListInfo = null;
      var autoRefillSubscriptionInfo = null;
      var fidoRewardsInfo = null;
      var deviceInfo = null;
      var planAndAddOnInfoError = null;
      var addonListInfoError = null;
      var autoRefillSubscriptionInfoError = null;
      var fidoRewardsInfoError = null;
      var deviceInfoError = null;
      var pricePlanInfo = null;
      var userInfo = null;
      var creditCardRegistrationInfo = null;
      var userInfoError = null;
      var creditCardRegistrationInfoError = null;
      var creditCardRegistrationInfoError = null;
      var selectedCTN = null;
      var selectedBAN = null;
      if (prepaidUserInfoService.getCTN() !== null & prepaidUserInfoService.getCTN() !== '' && prepaidUserInfoService.getBAN() !== null && prepaidUserInfoService.getBAN() !== '') {
        selectedCTN = prepaidUserInfoService.getCTN();
        selectedBAN = prepaidUserInfoService.getBAN();
      } else {
        selectedCTN = $sessionStorage.selectedCTN;
        selectedBAN = $sessionStorage.selectedBAN;
      }

      service.retrievePrepaidPlanInfo = function () {
        console.log('inside service.retrievePrepaidData ');
        var deferred = $q.defer();

        var promise = httpService.send(
          'v1/wireless/prepaid/dashboard/plan', // TODO : Need to change
          {
            accountNumber: selectedBAN,
            ctn: selectedCTN,
            language: language
          });

        promise.then(
          function (result) {
            if (result.data.error || result.data.status == 'Failed') {
              planAndAddOnInfoError = true;
              deferred.reject();
            } else {
              //alert('Got PlanAndAddOnInfo Successfully');
              planAndAddOnInfo = result.data;
              console.log('planAndAddOnInfo :: ' + planAndAddOnInfo);
              prepaidAirtimeBalanceService.setAirTimeBalance(planAndAddOnInfo.airtimeBalance);
              prepaidAirtimeBalanceService.setExpiryDate(planAndAddOnInfo.expiryDate);
              prepaidPlanInfoService.setAirTimePlanFee(planAndAddOnInfo.pricePlan);
              pricePlanInfo = null;
              if (result.data.planDetailsInfo != null) {
                if (language === 'en' || language === 'EN') {
                  pricePlanInfo = result.data.planDetailsInfo.en;
                } else {
                  pricePlanInfo = result.data.planDetailsInfo.fr;
                }
                if (result.data.planDetailsInfo.productId != null && result.data.planDetailsInfo.productId != '') {
                  prepaidPlanInfoService.setAirTimePlanSoc(result.data.planDetailsInfo.productId);
                } else {
                  prepaidPlanInfoService.setAirTimePlanSoc(planAndAddOnInfo.planSoc);
                }
                if (pricePlanInfo != null && pricePlanInfo.planComparison != null && pricePlanInfo.planComparison.planTitle != null && pricePlanInfo.planComparison.planTitle != '') {
                  prepaidPlanInfoService.setAirTimePlanTitle(pricePlanInfo.planComparison.planTitle);
                } else {
                  if (language === 'en' || language === 'EN') {
                    prepaidPlanInfoService.setAirTimePlanTitle(planAndAddOnInfo.description);
                  } else {
                    prepaidPlanInfoService.setAirTimePlanTitle(planAndAddOnInfo.descriptionFr);
                  }
                }
              } else {
                if (language === 'en' || language === 'EN') {
                  prepaidPlanInfoService.setAirTimePlanTitle(planAndAddOnInfo.description);
                } else {
                  prepaidPlanInfoService.setAirTimePlanTitle(planAndAddOnInfo.descriptionFr);
                }
                prepaidPlanInfoService.setAirTimePlanSoc(planAndAddOnInfo.planSoc);
              }
              planDesc = prepaidPlanInfoService.getAirTimePlanTitle();
              prepaidPlanInfoService.setAirTimePlanFeatures(pricePlanInfo);
              //getAutoRefillSubscriptionInfo(prepaidUserInfoService.getBAN(), prepaidUserInfoService.getCTN(), language);

              var promise = httpService.send(
                'v1/refill/autorefill/scheduled/details', // TODO : Need to change
                {
                  accountNumber: selectedBAN,
                  ctn: selectedCTN,
                  language: language
                });

              promise.then(
                function (result) {
                  if (result.data.error || result.data.error != '') {
                    autoRefillSubscriptionInfoError = true;
                    console.log('AutoRefillSubscriptionInfo Error');
                    deferred.reject();
                  } else {
                    console.log('Got AutoRefillSubscriptionInfo Successfully');
                    autoRefillSubscriptionInfo = result.data;
                    console.log('autoRefillSubscriptionInfo :: ' + autoRefillSubscriptionInfo);
                    prepaidAutoRefillInfoService.setAutoPayPlanInfo(autoRefillSubscriptionInfo.autoPayPlan);
                    prepaidAutoRefillInfoService.setAutoRefillBalanceInfo(autoRefillSubscriptionInfo.autoRefillBalance);
                    var $translate = $filter('translate');
                    var $currency = $filter('currency');
                    if (prepaidAutoRefillInfoService.getAutoPayPlanInfo().registeredFlag) {
                      var $date = $filter('date');
                      var scheduledRefillDate = new Date(autoRefillSubscriptionInfo.autoPayPlan.rechargeDate);
                      autoRefillSubscriptionInfo.autoPayPlan.rechargeDate = scheduledRefillDate;
                      prepaidAutoRefillInfoService.setAutoPayPlanSubContent('<p class="fido-tick-icon">' + $translate('global.label.nextPaymentOf') + ' ' + $currency(prepaidAutoRefillInfoService.getAutoPayPlanInfo().rechargeAmount) + '</p><p>' + $translate('global.label.autoPayPlanBridge') + ' ' + $date(scheduledRefillDate, 'MMMM dd, yyyy') + '</p>');
                      prepaidAutoRefillInfoService.setAutoPayPlanContentClass('tab pp-refill-margin-top-1-5 pp-refill-padding-top-0-2');
                      if (prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().registeredFlag) {
                        prepaidAutoRefillInfoService.setAutoRefillBalanceSubContent('<p class="fido-tick-icon-secondary">' + $translate('global.label.add') + ' ' + $currency(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().rechargeAmount) + ' ' + $translate('global.label.autoRefillBalanceBridge') + ' ' + $currency(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().balanceThreshold) + '</p>');
                        prepaidAutoRefillInfoService.setAutoRefillBalanceContentClass('tab pp-refill-margin-top-1-5 pp-refill-padding-top-0-9');
                      } else {
                        prepaidAutoRefillInfoService.setAutoRefillBalanceSubContent('');
                        prepaidAutoRefillInfoService.setAutoRefillBalanceContentClass('tab pp-refill-margin-top-1-5');
                      }
                    } else {
                      prepaidAutoRefillInfoService.setAutoPayPlanSubContent('');
                      prepaidAutoRefillInfoService.setAutoPayPlanContentClass('tab pp-refill-margin-top-1-5');
                      if (prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().registeredFlag) {
                        prepaidAutoRefillInfoService.setAutoRefillBalanceSubContent('<p class="fido-tick-icon-secondary">' + $translate('global.label.add') + ' ' + $currency(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().rechargeAmount) + ' ' + $translate('global.label.autoRefillBalanceBridge') + ' ' + $currency(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().balanceThreshold) + '</p>');
                        prepaidAutoRefillInfoService.setAutoRefillBalanceContentClass('tab pp-refill-margin-top-1-5 pp-refill-padding-top-0-9');
                      } else {
                        prepaidAutoRefillInfoService.setAutoRefillBalanceSubContent('');
                        prepaidAutoRefillInfoService.setAutoRefillBalanceContentClass('tab pp-refill-margin-top-1-5');
                      }
                    }
                    deferred.resolve();
                  }
                },
                function (reason) {
                  autoRefillSubscriptionInfoError = true;
                  deferred.reject();
                }
              );
            }
          },
          function (reason) {
            planAndAddOnInfoError = true;
            deferred.reject();
          }
        );
        return deferred.promise;
      };

      service.retrievePrepaidUserInfo = function () {
        var deferred = $q.defer();
        var promise = httpService.send(
          'v1/wireless/prepaid/creditcard/retrieve/ccinfo', // TODO : Need to change
          {
            accountNumber: selectedBAN,
            ctn: selectedCTN
          });

        promise.then(
          function (result) {
            if (result.data.error || result.data.status == 'Failed') {
              creditCardRegistrationInfoError = true;
              deferred.reject();
            } else {
              //alert('Got userInfo Successfully');
              creditCardRegistrationInfo = result.data;
              if (creditCardRegistrationInfo.registrationStatus) {
                //prepaidRegisteredCCInfoService.setCardScheme(creditCardRegistrationInfo.creditCardInfo.cardType);
                prepaidRegisteredCCInfoService.setTokenizedCCNumber(creditCardRegistrationInfo.creditCardInfo.creditCardNo);
                prepaidRegisteredCCInfoService.setMonth(creditCardRegistrationInfo.creditCardInfo.expiryDate);
                prepaidRegisteredCCInfoService.setYear(creditCardRegistrationInfo.creditCardInfo.expiryDate);
              }
              prepaidRegisteredCCInfoService.setCreditCardRegistrationStatus(creditCardRegistrationInfo.registrationStatus);
              /*retrieveUserInfo(prepaidUserInfoService.getBAN(), prepaidUserInfoService.getCTN(), stateName);*/

              var promise = httpService.send(
                'v1/wireless/prepaid/creditcard/retrieve/userinfo', // TODO : Need to change
                {
                  accountNumber: selectedBAN,
                  ctn: selectedCTN
                });

              promise.then(
                function (result) {
                  if (result.data.error || result.data.status == 'Failed') {
                    userInfoError = true;
                    deferred.reject();
                  } else {
                    //alert('Got userInfo Successfully');
                    userInfo = result.data;
                    console.log('userInfo :: ' + userInfo);
                    prepaidUserInfoService.setFirstName(userInfo.firstName);
                    prepaidUserInfoService.setLastName(userInfo.lastName);
                    prepaidUserInfoService.setEmailAddress(userInfo.emailAddress);
                    prepaidUserInfoService.setBillingAddress(userInfo.billingAddress);
                    deferred.resolve();
                  }
                },
                function (reason) {
                  userInfoError = true;
                  deferred.reject();
                }
              );
            }
          },
          function (reason) {
            creditCardRegistrationInfoError = true;
            deferred.reject();
          }
        );
        return deferred.promise;
      };

      return service;

    }]);
})();
